// src/firebase.js
// ─────────────────────────────────────────────────────
//  Memories by Inès — Configuration Firebase
//  memoriesbyines.com · contact@memoriesbyines.com
// ─────────────────────────────────────────────────────
//  INSTRUCTIONS :
//  1. Allez sur console.firebase.google.com
//  2. Créez un projet "memories-by-ines"
//  3. Ajoutez une app Web (</>)
//  4. Copiez votre config dans l'objet firebaseConfig ci-dessous
// ─────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey:            "AIzaSyBPcR4uQetNtx_nI65dzYmugwh6fdaH4cQ",
  authDomain:        "memories-by-ines.firebaseapp.com",
  projectId:         "memories-by-ines",
  storageBucket:     "memories-by-ines.firebasestorage.app",
  messagingSenderId: "428889403106",
  appId:             "1:428889403106:web:b11975509a2552f9cdf8bb",
  measurementId: "G-SEEJRCEBC5", 
};
  const app = initializeApp(firebaseConfig);

export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const functions = getFunctions(app);
export default app;
